import React from 'react';
import { Box, Chip, Typography } from '@mui/material';
import {
  AI_AGENT_SUGGESTIONS,
  AI_AGENT_SUGGESTIONS_LABEL,
  AI_AGENT_TOKENS,
  AI_AGENT_WELCOME_MESSAGE,
  AI_AGENT_WELCOME_SUBTITLE,
} from '../AIAgentConstants';

interface Props {
  onSelect: (text: string) => void;
  disabled: boolean;
}

export default function AIAgentInitialSuggestions({ onSelect, disabled }: Props) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 5,
        width: '100%',
        pt: 7,
        pb: 3,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 1,
          textAlign: 'center',
        }}
      >
        <Typography
          sx={{
            fontFamily: AI_AGENT_TOKENS.fontFamilyDisplay,
            fontWeight: 500,
            fontSize: 16,
            lineHeight: 1.6,
            letterSpacing: '0.15px',
            color: '#262626',
          }}
        >
          {AI_AGENT_WELCOME_MESSAGE}
        </Typography>
        <Typography
          sx={{
            fontFamily: AI_AGENT_TOKENS.fontFamily,
            fontWeight: 400,
            fontSize: 14,
            lineHeight: 1.43,
            letterSpacing: '0.17px',
            color: AI_AGENT_TOKENS.textSecondary,
          }}
        >
          {AI_AGENT_WELCOME_SUBTITLE}
        </Typography>
      </Box>

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, width: '100%' }}>
        <Typography
          sx={{
            fontFamily: AI_AGENT_TOKENS.fontFamily,
            fontWeight: 600,
            fontSize: 14,
            lineHeight: 1.43,
            letterSpacing: '0.17px',
            color: AI_AGENT_TOKENS.textSecondary,
          }}
        >
          {AI_AGENT_SUGGESTIONS_LABEL}
        </Typography>

        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
          {AI_AGENT_SUGGESTIONS.map((suggestion) => (
            <Chip
              key={suggestion.id}
              label={suggestion.text}
              clickable={!disabled}
              disabled={disabled}
              onClick={() => onSelect(suggestion.text)}
              aria-label={suggestion.text}
              variant="outlined"
              sx={{
                height: 'auto',
                minHeight: 32,
                borderRadius: '100px',
                borderColor: AI_AGENT_TOKENS.primary,
                backgroundColor: AI_AGENT_TOKENS.white,
                '& .MuiChip-label': {
                  px: 1.5,
                  py: 0.5,
                  fontFamily: AI_AGENT_TOKENS.fontFamily,
                  fontWeight: 500,
                  fontSize: 12,
                  lineHeight: '20px',
                  letterSpacing: '0.14px',
                  color: AI_AGENT_TOKENS.primary,
                  whiteSpace: 'normal',
                },
              }}
            />
          ))}
        </Box>
      </Box>
    </Box>
  );
}
